import { render, staticRenderFns } from "./ModalCriarEditarPontuacaoProfissional.vue?vue&type=template&id=69e56236&scoped=true"
import script from "./ModalCriarEditarPontuacaoProfissional.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarPontuacaoProfissional.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarEditarPontuacaoProfissional.vue?vue&type=style&index=0&id=69e56236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e56236",
  null
  
)

export default component.exports